module.exports = {
  '_default': require('./5_0'),
  '5.0': require('./5_0'),
  '2.4': require('./2_4'),
  '2.3': require('./2_3'),
  '2.2': require('./2_2'),
  '2.1': require('./2_1'),
  '5.x': require('./5_x'),
  'master': require('./master')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/elasticsearch/src/lib/apis/browser_index.js
// module id = ./node_modules/elasticsearch/src/lib/apis/browser_index.js
// module chunks = vendor